import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const ProarnesAPI = {

  cableado: async function (data, cancel = false) {
    const response = await api.request({
      url: '/proarnes/rm-ca-dat',
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  coberturas: async function (data, cancel = false) {
    const response = await api.request({
      url: '/proarnes/rm-co-mc',
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  conectores: async function (data, cancel = false) {
    const response = await api.request({
      url: '/proarnes/rm-co-dat',
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  terminales: async function (data, cancel = false) {
    const response = await api.request({
      url: '/proarnes/rm-ter-dat',
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

}



// defining the cancel API object for ProductAPI
//const cancelApiObject = defineCancelApiObject(ImportAPI)